import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FloorTenantCompany } from '../../../../../core/models/provider-parking/floor-tenant-company.model';
import { ApiFloorTenantCompanyService } from '../../../../../core/services/api/provider-parking/api-floor-tenant-company.service';
import { ApiTableService } from '../../../../../core/services/api-table.service';
import { ToastService } from 'angular-toastify';
import { optionResponse } from '../../../../../core/models/form.model';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-modal-floor-tenant-company',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-floor-tenant-company.component.html',
  styleUrl: './modal-floor-tenant-company.component.css'
})
export class ModalFloorTenantCompanyComponent implements OnInit {
  @Input() data: FloorTenantCompany | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() saveSuccess = new EventEmitter<void>();

  public form: FloorTenantCompany = this.getInitialForm();
  public isLoading: boolean = false;
  public openDropdown: string | null = null;

  // Dropdowns
  public siteList: optionResponse | null = null;
  public parkingTypes = ['อาคารจอดรถยนต์', 'อาคารจอดรถมอเตอร์ไซค์', 'ลานจอดรถกลางแจ้ง'];

  // Search states for dropdowns
  public searchParkingTypeText: string = '';
  public searchSiteText: string = '';

  get filteredParkingTypes(): string[] {
    const s = (this.searchParkingTypeText || '').toLowerCase();
    return this.parkingTypes.filter(t => t.toLowerCase().includes(s));
  }

  get filteredSites(): any[] {
    if (!this.siteList || !this.siteList.data) return [];
    const s = (this.searchSiteText || '').toLowerCase();
    return this.siteList.data.filter((site: any) => site.name.toLowerCase().includes(s));
  }

  constructor(
    private apiService: ApiFloorTenantCompanyService,
    private apiTableService: ApiTableService,
    private toast: ToastService
  ) { }

  ngOnInit(): void {
    if (this.data) {
      this.form = { ...this.data };
      this.searchParkingTypeText = this.form.parkingType || '';
      this.searchSiteText = this.form.serviceArea || '';
    }
    this.fetchSites();
  }

  public onClickInsideModal(event: Event): void {
    event.stopPropagation();
    this.closeDropdowns();
  }

  public closeDropdowns(): void {
    if (this.openDropdown === 'parkingType') {
      if (this.parkingTypes.includes(this.searchParkingTypeText)) {
        this.form.parkingType = this.searchParkingTypeText;
      } else {
        this.searchParkingTypeText = this.form.parkingType || '';
      }
    } else if (this.openDropdown === 'site') {
      const siteNames = this.siteList?.data?.map((s: any) => s.name) || [];
      if (siteNames.includes(this.searchSiteText)) {
        this.form.serviceArea = this.searchSiteText;
      } else {
        this.searchSiteText = this.form.serviceArea || '';
      }
    }
    this.openDropdown = null;
  }

  public onInputFocus(menu: string): void {
    if (this.openDropdown && this.openDropdown !== menu) {
      this.closeDropdowns();
    }
    this.openDropdown = menu;
  }

  private getInitialForm(): FloorTenantCompany {
    return {
      id: 0,
      name: '',
      parkingType: '',
      lots: 0,
      serviceArea: '',
      image1: '',
      image2: '',
      image3: '',
      isOnline: false
    };
  }

  private fetchSites(): void {
    this.apiTableService.getParkingSiteList().subscribe({
      next: (res) => this.siteList = res,
      error: (err) => console.error('Fetch sites error:', err)
    });
  }

  public toggleDropdown(id: string, event: Event): void {
    event.stopPropagation();
    if (this.openDropdown === id) {
      this.closeDropdowns();
    } else {
      if (this.openDropdown) this.closeDropdowns();
      this.openDropdown = id;
    }
  }

  public selectOption(field: keyof FloorTenantCompany, value: any): void {
    (this.form as any)[field] = value;
    if (field === 'parkingType') {
      this.searchParkingTypeText = value;
    } else if (field === 'serviceArea') {
      this.searchSiteText = value;
    }
    this.openDropdown = null;
  }

  public onSave(): void {
    this.closeDropdowns(); // Ensure inputs are validated first
    
    if (!this.form.name || !this.form.serviceArea || !this.form.parkingType) {
      this.toast.error('กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง');
      return;
    }

    this.isLoading = true;
    this.apiService.createFloorTenantCompany(this.form)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: () => {
          this.toast.success('บันทึกข้อมูลสำเร็จ');
          this.saveSuccess.emit();
          this.close.emit();
        },
        error: (err) => {
          console.error('Save error:', err);
          this.toast.error('ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง');
        }
      });
  }

  public onCancel(): void {
    this.close.emit();
  }
}
